import { RequestVenue } from './request-venue'
import { DatePipe } from '@angular/common';

export class RequestVenueExport {
 

  Company_Name: string;
  Request_Number: string;
  Request_Date: string;
  TSD_Approval_Date: string;

  Request_Status: string;
  Requestor_Name: string;
  On_Behalf_Of: string;

  First_Name: string;
  Last_Name: string;
  Job_Title: string;
  Email: string;
  Phone: string;

  Venue: string;
  Venue_Type: string;
  Venue_Layout: string;

  Meeting_Date: string;
  Meeting_To_Date: string;
  Start_Time: string;
  End_Time: string;
  Duration: string;
  Charge_Type: string;
  Charge_Amount: string;

  Meeting_Title: string;
  Meeting_Description: string;

  constructor(request: RequestVenue, datePipe: DatePipe) {
    

    this.Company_Name = request.companyName;
    this.Request_Number = request.requestNumber;
    this.Request_Date = typeof request.requestDate == "object" ? datePipe.transform(request.requestDate, "yyyy-MM-dd") : datePipe.transform(new Date(request.requestDate), "yyyy-MM-dd");
    this.TSD_Approval_Date = request.finalApprovalHistory && (typeof request.finalApprovalHistory.eventDate == "object" ? datePipe.transform(request.finalApprovalHistory.eventDate, "yyyy-MM-dd") : datePipe.transform(new Date(request.finalApprovalHistory.eventDate), "yyyy-MM-dd")); 

    this.Request_Status = request.requestStatusName;
    this.Requestor_Name = request.requestorName;
    this.On_Behalf_Of = request.onBehalfName;

    this.First_Name = request.firstName;
    this.Last_Name = request.lastName;
    this.Job_Title = request.jobTitle;
    this.Email = request.email;
    this.Phone = request.phone;

    this.Venue = request.venueName;
    this.Venue_Type = request.venueTypeName;
    this.Venue_Layout = request.venueLayoutName;

    this.Meeting_Date = typeof request.meetingDate == "object" ? datePipe.transform(request.meetingDate, "yyyy-MM-dd") : datePipe.transform(new Date(request.meetingDate), "yyyy-MM-dd");
    this.Meeting_To_Date = typeof request.meetingToDate == "object" ? datePipe.transform(request.meetingToDate, "yyyy-MM-dd") : datePipe.transform(new Date(request.meetingToDate), "yyyy-MM-dd");
    this.Start_Time = request.startTimeFullString;
    this.End_Time = request.endTimeFullString;
    this.Duration = this.calculateMeetingDuration(request);
    this.Charge_Type = request.roomChargeType;
    this.Charge_Amount = request.roomChargeAmount;
    this.Meeting_Title = request.meetingTitle;
    this.Meeting_Description = request.meetingDescription;
    
  }

  public calculateMeetingDuration(request: RequestVenue): string {

    //Set the breakdown
    var startHours = request.startTimeHours;
    var startMinutes = request.startTimeMinutes;
    var startSymbol = request.startTimeSymbol;

    var endHours = request.endTimeHours;
    var endMinutes = request.endTimeMinutes;
    var endSymbol = request.endTimeSymbol;

    if (!(startHours && endHours))
      return "";

    // Set the unit values in milliseconds.  
    var msecPerMinute = 1000 * 60;
    var msecPerHour = msecPerMinute * 60;

    // Set a date and get the milliseconds  
    var startDate = new Date(request.meetingDate);
    startDate.setHours(startSymbol == 'AM' || startHours == 12 ? startHours : (startHours + 12), startMinutes, 0, 0);

    var endDate = new Date(request.meetingDate);
    endDate.setHours(endSymbol == 'AM' || endHours == 12 ? endHours : (endHours + 12), endMinutes, 0, 0);

    // Get the difference in milliseconds.  
    var interval = endDate.getTime() - startDate.getTime();
    // Calculate the hours, minutes, and seconds.  
    var hours = Math.floor(interval / msecPerHour);
    interval = interval - (hours * msecPerHour);

    var minutes = Math.floor(interval / msecPerMinute);
    interval = interval - (minutes * msecPerMinute);

    //Calculate duration
    var durationString = hours.toString() + ":" + minutes.toString();
    return durationString;
  }
}



// WEBPACK FOOTER //
// ./src/app/core/models/request-venue-export.ts